import { ButtonClickTrackingPlugin } from '@snowplow/browser-plugin-button-click-tracking';
import { LinkClickTrackingPlugin } from '@snowplow/browser-plugin-link-click-tracking';
import { gtagsAdapter } from '@utilitywarehouse/tracking-adapter-gtm-web';
import {
  mixpanelAdapter,
  sessionReplayInterceptor,
} from '@utilitywarehouse/tracking-adapter-mixpanel-web';
import {
  client,
  snowplowAdapter,
} from '@utilitywarehouse/tracking-adapter-snowplow-web';
import { trackingClient } from '@utilitywarehouse/tracking-core';

import {
  GTM_GATEWAY_SRC,
  GTM_KEY,
  MIXPANEL_REPLAYS_TOKEN,
  SNOWPLOW_COLLECTOR_URL,
} from '@constants/config';
import {
  applyInitialBasketEventProperty,
  getInitialFlagsContext,
} from '@tracking/mixpanelFlagsContext';

const isWebView =
  typeof window !== 'undefined' &&
  window?.navigator?.userAgent?.indexOf('uwPartnerApp') > -1;

export const tracker = trackingClient({
  adapters: [
    snowplowAdapter({
      collector: SNOWPLOW_COLLECTOR_URL,
      appId: 'quoting_platform',
      plugins: [LinkClickTrackingPlugin(), ButtonClickTrackingPlugin()],
      options: {
        debug: false,
        webView: isWebView,
        keepWebTracking: true,
      },
    }),
    gtagsAdapter({
      key: GTM_KEY || '',
      scriptTagAttributes: { 'data-ot-ignore': '' },
      // scriptSrc will remain undefined if not provided
      // and default back to `https://www.googletagmanager.com`
      // which is necessary for dev environments.
      scriptSrc: GTM_GATEWAY_SRC,
    }),
  ],
});

// Session replays, feature flags and experiments.
if (MIXPANEL_REPLAYS_TOKEN) {
  const adapter = mixpanelAdapter({
    token: MIXPANEL_REPLAYS_TOKEN,
    options: {
      flags: {
        // distinct_id and device_id are supplied by the SDK itself; this only
        // adds basket_id, so flags may be bucketed per shared basket. Kept in
        // step with the active basket by `useMixpanelFlagsContextSync`.
        context: getInitialFlagsContext(),
        // Persisted variants are keyed by distinct_id, not by basket, so they
        // are only a fallback for when the network fails.
        persistence: {
          variantLookupPolicy: 'networkFirst',
        },
      },
      enableSentryIntegration: true,
      record_sessions_percent: 100,
      record_network: true,
      record_mask_text_selector: '',
      record_mask_all_inputs: false,
      record_unmask_input_selector: 'input, textarea, select',
      record_mask_input_selector: '.mp-mask',
    },
  });

  applyInitialBasketEventProperty();

  tracker.addAdapter(adapter);
  tracker.addInterceptor(sessionReplayInterceptor);
}

tracker.startSession(client?.getDomainUserId());

export const snowplowClient = client;
